var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgRepeat(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 31 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M4.935 13.23c-.609 0-1.078-.562-1.03-1.171v-.375c.233-4.594 4.03-8.204 8.624-8.204h5.625V1.793c0-.938.703-1.688 1.64-1.688.423 0 .798.188 1.126.47l3.61 3.234c.233.187.374.515.374.796 0 .329-.14.657-.375.844l-3.61 3.235a1.68 1.68 0 01-1.124.421c-.89 0-1.64-.75-1.64-1.64V5.73h-5.626c-3.422 0-6.187 2.672-6.375 6.094v.375a1.117 1.117 0 01-1.219 1.031zm15.47-7.078l1.687-1.547-1.688-1.5v3.047zm6.421 4.828c.61.047 1.078.563 1.078 1.22l-.047.374c-.234 4.594-4.031 8.156-8.625 8.156h-5.578v1.735c0 .89-.75 1.64-1.687 1.64a1.68 1.68 0 01-1.125-.421l-3.61-3.235c-.234-.187-.328-.515-.328-.797 0-.328.094-.656.328-.843l3.61-3.235a1.68 1.68 0 011.125-.422c.937 0 1.687.75 1.687 1.641v1.688h5.578c3.422 0 6.235-2.626 6.375-6.047l.047-.375c0-.61.516-1.079 1.172-1.079zm-15.422 7.125l-1.734 1.5 1.734 1.547v-3.047z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgRepeat);
export default ForwardRef;
